import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Divider,
  SxProps,
} from '@mui/material';

const TABS = [
  { name: 'percentage', label: 'Porcentagem' },
  { name: 'amount', label: 'Montante' },
];

const TabNavigation = ({
  value,
  handleSelectTab,
  tabs = ['percentage', 'amount'],
}: {
  value: string;
  handleSelectTab: (value: 'percentage' | 'amount') => void;
  tabs?: string[];
  styles?: SxProps;
}) => {
  return (
    <Box px={1}>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          handleSelectTab(newValue);
        }}
        showLabels
        sx={(theme) => ({
          height: 40,
          width: 'max-content',
          justifyContent: 'flex-start',
          [theme.breakpoints.down('xs')]: { width: 'auto' },
        })}>
        {tabs?.map((tab, index) => (
          <BottomNavigationAction
            key={`${tab}-${index}`}
            label={TABS.find((t) => t.name === tab)?.label}
            value={tab}
          />
        ))}
      </BottomNavigation>
      <Divider />
    </Box>
  );
};

export default TabNavigation;
